import { merge } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import template from '@/components/services/settings/template'

export default function(options) {
  const merged = merge({}, { serviceName: Services.settingsUser }, options)

  return {
    computed: {
      component() {
        return template(merged)
      }
    },

    render(h) {
      return h(this.component)
    }
  }
}

